import { render, staticRenderFns } from "./BannedCard.vue?vue&type=template&id=336141dd&scoped=true&lang=true&"
import script from "./BannedCard.vue?vue&type=script&lang=js&"
export * from "./BannedCard.vue?vue&type=script&lang=js&"
import style0 from "./BannedCard.vue?vue&type=style&index=0&id=336141dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336141dd",
  null
  
)

export default component.exports